// import { Link } from 'react-router-dom';
import styled from 'styled-components';


export const PageTitleText  = styled.h1
.attrs(() => ({
  className: '',
}))`
color:  #18181B;
font-family: Plus Jakarta Sans;
font-size: 20px;
font-style: normal;
font-weight: 700;
margin:0px !important;
`;

export const PageContainerTitleText  = styled.h2
.attrs(() => ({
  className: '',
}))`
color: #18181B;
font-family: Plus Jakarta Sans !important;
font-size: 16px;
font-style: normal;
font-weight: 600;
margin-to:0px !important;

`;
